import { UserLockStatus } from "app/services/UserAccount";

class UserAccountController {
    userLockStatus: UserLockStatus;

    static $inject = ['dialogs', 'UserAccount', 'ContactBasicDetailsPage'];
    constructor(private dialogs, private UserAccount, ContactBasicDetailsPage) {

        this.UserAccount
            .locked()
            .$promise
            .then(lockedStatus => {
                this.userLockStatus = lockedStatus;
            }, () => {
                this.dialogs.error('Error', 'Unable to retrieve user status.');
            });
    }

    unlock() {
        this.UserAccount
            .unlock()
            .$promise
            .then(_ => {
                this.userLockStatus = {
                    ...this.userLockStatus,
                    isLockedOut: false
                };
            });
    }
}

angular
    .module('app')
    .controller('UserAccountController', UserAccountController)